module.exports = __webpack_public_path__ + "static/mariusz-tlo-v2.bdd5e6b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/universal/img/mariusz-tlo-v2.jpg
// module id = 823
// module chunks = 168707334958949